import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  failedLogs: [],
};

const etlSeqSlice = createSlice({
  name: "etlSeq",
  initialState,
  reducers: {
    setFailedLogs: (state, action) => {
      state.failedLogs = action.payload;
    },
  },
});

export const { setFailedLogs } = etlSeqSlice.actions;
export default etlSeqSlice.reducer;
